import React, { useRef } from 'react'
import Navbar from '../Components/Navbar'
import ModernHero from '../Components/Influncers/ModernHero'
import Into from '../Components/Influncers/Into'
import Footer from '../Components/Foooter'
import PageSEO from '../Components/SEO/PageSEO'

const Influencers = () => {
  const intoRef = useRef(null);

  const handleJoinCreator = () => {
    // This will be handled by the Into component
    if (intoRef.current) {
      intoRef.current.openRegisterModal();
    }
  };

  const handleHireCreators = () => {
    // Scroll to the featured influencers section
    if (intoRef.current) {
      intoRef.current.scrollToFeatured();
    }
  };

  return (
   <>
   <PageSEO 
     title="Best Influencer Marketing Agencies In Ramamurthy Nagar | Cyborgsapient Pvt. Ltd."
     description="Looking for a trusted influencer marketing agency in Ramamurthy Nagar? Cyborgsapient Pvt. Ltd. connects brands with the right influencers for measurable results."
     keywords="influencer marketing agency in ramamurthy nagar, best influencer marketing agencies in ramamurthy nagar, brand influencer bangalore"
     url="https://cyborgsapient.com/influencer"
   />
   <Navbar/>
   <ModernHero 
     onJoinCreator={handleJoinCreator}
     onHireCreators={handleHireCreators}
   />
   <Into ref={intoRef}/>
   <Footer/>
   </>
  )
}

export default Influencers
